export const useLocalStorage = (key) => {
  const setItem = (value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.log(error);
    }
  };

  const getItem = () => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : undefined;
    } catch (error) {
      console.log(error);
    }
  };

  const removeItem = () => {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.log(error);
    }
  };

  const setMultipleItems = (items) => {
    try {
      Object.entries(items).forEach(([k, v]) => {
        window.localStorage.setItem(k, JSON.stringify(v));
      });
    } catch (error) {
      console.log(error);
    }
  };

  return { setItem, getItem, removeItem, setMultipleItems };
};
